import {DARK_GREEN2} from '../../../../../globalVariables/GlobalVariables';

const LinkIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 24 24"
    >
        <path  
            d="M14 3H21V10"
            stroke={DARK_GREEN2}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path  
            d="M10 14L21 3"
            stroke={DARK_GREEN2}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path  
            d="M21 21H3V3H12"
            stroke={DARK_GREEN2}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default LinkIcon;
